import { type ReactNode } from 'react';
import type { CollectorSummary, DailyEarning } from '../types';
import { StatusStrikes } from './status-strikes';
import { StatusToday } from './status-today';

type Props = {
  summary: CollectorSummary;
  daily: DailyEarning[] | undefined;
};

export function StatusCard({ summary, daily }: Props): ReactNode {
  return (
    <div className="flex h-full flex-col rounded-xl bg-white/[0.02] p-base">
      <StatusStrikes summary={summary} daily={daily} />
      <StatusToday summary={summary} daily={daily} />
    </div>
  );
}
